if (!customElements.get('inline-countdown-timer')) {
  customElements.define('inline-countdown-timer', class InlineCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.MS_IN_SEC = 1000;
      this.MS_IN_MIN = 60 * this.MS_IN_SEC;
      this.MS_IN_HRS = 60 * this.MS_IN_MIN;
      this.MS_IN_DAY = 24 * this.MS_IN_HRS;

      this.selectorMapping = {
        day: '[data-timer-day]',
        hour: '[data-timer-hour]',
        minute: '[data-timer-minute]',
        second: '[data-timer-second]',
      };

      this.units = ['day', 'hour', 'minute', 'second'];
      this.duration = this.dataset.duration;
      this.shouldAddLeadingZero = true;

      this.initCountdown();
    }

    initCountdown() {
      this.targetTime = this.parseDueDate(this.dataset.dueDate);

      if (this.targetTime === null) {
        return;
      }

      this.fetchDomElements();
      this.startTime = Date.now();
      if (this.targetTime > this.startTime) {
        this.beginCountdown();
      } else {
        this.updateDisplay(0);
      }
    }

    parseDueDate(value) {
      const match = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/.exec((value || '').trim());
      if (!match) {
        return null;
      }

      const [day, month, year, hour, minute, second] = match.slice(1).map(Number);
      const date = new Date(year, month - 1, day, hour, minute, second);

      const isExactMatch =
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        date.getHours() === hour &&
        date.getMinutes() === minute &&
        date.getSeconds() === second;

      return isExactMatch ? date.getTime() : null;
    }

    fetchDomElements() {
      this.elements = {};
      this.units.forEach((unit) => {
        this.elements[unit] = this.querySelector(this.selectorMapping[unit]);
      });
    }

    beginCountdown() {
      this.updateDisplay(Math.max(0, this.targetTime - Date.now()));
      this.intervalId = setInterval(() => {
        const remainingTime = this.targetTime - Date.now();
        if (remainingTime <= 0) {
          this.updateDisplay(0);
          this.terminateCountdown();
        } else {
          this.updateDisplay(remainingTime);
        }
      }, 1000);
    }

    updateDisplay(remainingTime) {
      const timeComponents = this.computeTimeComponents(remainingTime);
      this.units.forEach((unit) => {
        if (this.elements[unit]) {
          this.elements[unit].textContent = this.formatTimeComponent(timeComponents[unit]);
        }
      });
    }

    computeTimeComponents(ms) {
      return {
        day: Math.floor(ms / this.MS_IN_DAY),
        hour: Math.floor((ms % this.MS_IN_DAY) / this.MS_IN_HRS),
        minute: Math.floor((ms % this.MS_IN_HRS) / this.MS_IN_MIN),
        second: Math.floor((ms % this.MS_IN_MIN) / this.MS_IN_SEC),
      };
    }

    formatTimeComponent(value) {
      return this.shouldAddLeadingZero && value < 10 ? `0${value}` : value.toString();
    }

    terminateCountdown() {
      clearInterval(this.intervalId);
    }
  });
}
